var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUserProfile(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M37 22C37 30.2842 30.2842 37 22 37C13.7157 37 7 30.2842 7 22C7 13.7157 13.7157 7 22 7C30.2842 7 37 13.7157 37 22Z",
    fill: "#2657B0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M29.2105 32.5168C27.1597 33.9256 24.6761 34.75 22 34.75C19.3238 34.75 16.8403 33.9255 14.7895 32.5167C13.8837 31.8945 13.4966 30.7093 14.0233 29.7448C15.115 27.7453 17.3646 26.5 22 26.5C26.6354 26.5 28.885 27.7455 29.9767 29.7448C30.5033 30.7093 30.1162 31.8946 29.2105 32.5168Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M21.9999 22C24.4853 22 26.4999 19.9854 26.4999 17.5C26.4999 15.0147 24.4853 13 21.9999 13C19.5147 13 17.5 15.0147 17.5 17.5C17.5 19.9854 19.5147 22 21.9999 22Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserProfile);
export default __webpack_public_path__ + "static/media/user-profile.a54f30e8d36d1778515047fe810812ed.svg";
export { ForwardRef as ReactComponent };